var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-image',{attrs:{"src":_vm.image.src,"fallback-src":_vm.image.fallbackSrc,"image-class":_vm.imageClass,"alt":"Prize Image"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e38442","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/image/PrizeSingleDisplayModeImage.vue
// module id = null
// module chunks = 